// Styled components
import styled from "@emotion/styled";

export const AboutContainer = styled.div`
  margin: 2rem auto;
  max-width: 800px;
  padding: 1rem;
  font-family: Arial, sans-serif;
  text-align: center;
`;

export const GroupPhoto = styled.img`
  width: 100%;
  max-width: 500px;
  border-radius: 10px;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export const AboutText = styled.p`
  font-size: 1.2rem;
  line-height: 1.6;
  color: #555;
  margin: 0 auto;
`;